export default {"src":"/pro/_next/static/media/crv.2fb3c73e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};